/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_No_MatchInputs */

const cs_portals_no_match = /** @type {(inputs: Portals_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný portál neodpovídá filtru.`)
};

const en_portals_no_match = /** @type {(inputs: Portals_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No portal matches the filter.`)
};

/**
* | output |
* | --- |
* | "No portal matches the filter." |
*
* @param {Portals_No_MatchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_no_match = /** @type {((inputs?: Portals_No_MatchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_No_MatchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_no_match(inputs)
	return cs_portals_no_match(inputs)
});